import React from 'react'
import classNames from 'classnames'

import { Section, Text } from 'common'

import * as style from './linkCta.module.scss'
import Ctas from '../Ctas'

export default function LinkCta({
  title,
  subtitle,
  titleAs = 'h2',
  subtitleAs = 'body2',
  className,
  ctas,
  options,
  customCta: CustomCta,
}) {
  return (
    <Section className={classNames(style.linkCta, className)}>
      <div className={classNames('linkCta-content', style.content)}>
        <Text
          title={title}
          titleAs={titleAs}
          subtitle={subtitle}
          subtitleAs={subtitleAs}
        />
        {ctas && <Ctas ctas={ctas} options={options} className={style.ctas} />}
        {CustomCta && <CustomCta />}
      </div>
    </Section>
  )
}
